<template>
  <Transition name="modal-fade">
    <div v-if="visible" class="modal-overlay" @click.self="close">
      <div class="custom-modal">
        <div class="modal-header">
          <h3>版本历史收录</h3>
          <button class="close-btn" @click="close">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>
        
        <div class="modal-body">
          <div v-if="loading" class="loading-state">
            <i class="fa-solid fa-spinner fa-spin"></i>
            加载中...
          </div>
          <div v-else-if="!history || history.length === 0" class="empty-state">
             暂无历史版本收录
          </div>
          <div v-else class="history-list">
            <div v-for="(h, index) in history" :key="h.version" class="history-item" :class="{ expanded: expandedItems.includes(index) }">
              <div class="version-header" @click="toggleExpand(index)">
                <div class="version-info">
                  <span class="version-tag">v{{ h.version }}</span>
                  <span v-if="h.isGithub" style="margin-left: 6px; color: #409eff; font-size: 14px;" title="来源: GitHub Releases">
                    <i class="fa-brands fa-github"></i>
                  </span>
                  <span class="update-time">{{ formatDate(h.updated) }}</span>
                </div>
                <div class="version-meta">
                  <span class="file-count">{{ h.files ? h.files.length : 0 }} 个文件</span>
                  <i class="fa-solid fa-chevron-down expand-icon"></i>
                </div>
              </div>
              
              <Transition name="expand">
                <div v-if="expandedItems.includes(index)" class="file-list-container">
                  <div class="file-list">
                    <div v-for="f in h.files" :key="f.name" class="file-row" @click="handleDownload(f)" :title="'下载 ' + f.name">
                      <div class="file-info">
                        <i class="fa-solid fa-file-lines"></i>
                        <span class="file-name">{{ f.name }}</span>
                        <span class="file-size">{{ formatSize(f.size) }}</span>
                      </div>
                      <div class="file-actions">
                        <i class="fa-solid fa-cloud-arrow-down download-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </Transition>
            </div>
          </div>
        </div>
        
        <div class="modal-footer">
          <button class="close-footer-btn" @click="close">关闭</button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'HistoryModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    history: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:visible', 'download'],
  data() {
    return {
      expandedItems: []
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.expandedItems = []
      }
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    toggleExpand(index) {
      const idx = this.expandedItems.indexOf(index)
      if (idx > -1) {
        this.expandedItems.splice(idx, 1)
      } else {
        this.expandedItems.push(index)
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
    },
    formatSize(size) {
      if (!size) return 'Unknown'
      const mb = size / (1024 * 1024)
      return mb < 0.1 ? (size / 1024).toFixed(2) + ' KB' : mb.toFixed(2) + ' MB'
    },
    handleDownload(file) {
      this.$emit('download', file)
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-dialog);

}

.custom-modal {
  background: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 550px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: 80vh;
}

.modal-header {
  padding: 15px 20px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fafafa;
}

.modal-header h3 {
  margin: 0;
  font-family: '猫啃网糖圆体';
  font-size: 1.25em;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #bbb;
  transition: all 0.3s;
}

.close-btn:hover {
  color: #ff4d4f;
  transform: rotate(90deg);
}

.modal-body {
  padding: 0;
  flex: 1;
  overflow-y: auto;
  background: #fff;
}

.loading-state, .empty-state {
  padding: 40px;
  text-align: center;
  color: #999;
  font-family: '爱点风雅黑';
}

.loading-state i {
  margin-right: 8px;
  color: #667eea;
}

.history-list {
  display: flex;
  flex-direction: column;
}

.history-item {
  padding: 0;
  border-bottom: 1px solid #f5f5f5;
  transition: background 0.2s;
}

.version-header {
  padding: 15px 20px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.2s;
}

.version-header:hover {
  background: #fafbff;
}

.history-item.expanded .version-header {
  background: #667eea;
}

.history-item.expanded .version-header .version-tag {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border-color: rgba(255, 255, 255, 0.4);
}

.history-item.expanded .version-header .update-time,
.history-item.expanded .version-header .file-count,
.history-item.expanded .version-header .expand-icon {
  color: #fff;
}

.version-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.version-meta {
  display: flex;
  align-items: center;
  gap: 15px;
}

.file-count {
  font-size: 0.85em;
  color: #999;
  font-family: '爱点风雅黑';
}

.expand-icon {
  font-size: 0.9em;
  color: #ccc;
  transition: transform 0.3s ease;
}

.history-item.expanded .expand-icon {
  transform: rotate(180deg);
}

.file-list-container {
  overflow: hidden;
  background: #fff;
}

.file-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 15px 20px;
}

.version-tag {
  background: #ebf0ff;
  color: #667eea;
  padding: 2px 10px;
  border-radius: 4px;
  font-weight: bold;
  font-family: '猫啃网糖圆体';
  font-size: 0.9em;
  border: 1px solid #d0daff;
  transition: all 0.3s;
}

.update-time {
  color: #999;
  font-size: 0.85em;
  transition: all 0.3s;
}

.file-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #fdfdfd;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  transition: all 0.2s;
  cursor: pointer;
}

.file-row:hover {
  border-color: #667eea;
  background: #f8faff;
  transform: translateX(5px);
}

.file-info {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}

.file-info i {
  color: #666;
  font-size: 0.9em;
}

.file-name {
  color: #444;
  font-size: 0.95em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: '爱点风雅黑';
}

.file-size {
  color: #999;
  font-size: 0.8em;
  margin-left: 4px;
}

.file-actions {
  display: flex;
  gap: 8px;
  margin-left: 15px;
}

.download-icon {
  color: #67c23a;
  font-size: 1.2em;
  opacity: 0.6;
  transition: all 0.3s;
}

.file-row:hover .download-icon {
  opacity: 1;
  transform: scale(1.1);
}

.modal-footer {
  padding: 12px 20px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
  background: #fafafa;
}

.close-footer-btn {
  padding: 8px 24px;
  border: 1px solid #dcdcdc;
  background: #fff;
  color: #666;
  border-radius: 20px;
  cursor: pointer;
  font-family: '爱点风雅黑';
  transition: all 0.3s;
}

.close-footer-btn:hover {
  border-color: #667eea;
  color: #667eea;
  background: #f0f4ff;
}

/* Dark Theme Support */
.dark-theme .custom-modal {
  background: #1a1a1a;
  color: #eee;
}

.dark-theme .modal-header, .dark-theme .modal-footer {
  background: #252525;
  border-color: #333;
}

.dark-theme .modal-header h3 {
  color: #eee;
}

.dark-theme .modal-body {
  background: #1a1a1a;
}

.dark-theme .history-item {
  border-color: #333;
}

.dark-theme .version-header:hover {
  background: #252525;
}

.dark-theme .file-list-container {
  background: #1a1a1a;
}

.dark-theme .file-row {
  background: #222;
  border-color: #333;
}

.dark-theme .file-row:hover {
  border-color: #667eea;
  background: #2a2a2a;
}

.dark-theme .file-name {
  color: #ccc;
}

.dark-theme .file-info i {
  color: #888;
}

.dark-theme .version-tag {
  background: #2a2a2a;
  color: #8fa1ff;
  border-color: #3f4a80;
}

.dark-theme .file-size, .dark-theme .file-count {
  color: #666;
}

.dark-theme .loading-state, .dark-theme .empty-state {
  background: #1a1a1a;
  color: #888;
}

.dark-theme .close-footer-btn {
  background: #2d2d2d;
  border-color: #444;
  color: #aaa;
}

.dark-theme .close-footer-btn:hover {
  background: #383838;
  border-color: #8fa1ff;
  color: #8fa1ff;
}

/* Animations */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active .custom-modal {
  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.modal-fade-leave-active .custom-modal {
  transition: transform 0.3s ease-in;
}

.modal-fade-enter-from .custom-modal {
  transform: scale(0.9) translateY(10px);
}

.modal-fade-leave-to .custom-modal {
  transform: scale(0.95) translateY(10px);
}

/* Expand Animation */
.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease-in-out;
  max-height: 500px;
}

.expand-enter-from,
.expand-leave-to {
  max-height: 0;
  opacity: 0;
}

@media (max-width: 480px) {
  .custom-modal {
    width: 100%;
    border-radius: 20px 20px 0 0;
    position: absolute;
    bottom: 0;
    margin: 0;
    max-width: none;
    max-height: 85vh;
  }
  
  .modal-overlay {
    align-items: flex-end;
  }
  
  .modal-fade-enter-from .custom-modal,
  .modal-fade-leave-to .custom-modal {
    transform: translateY(100%);
  }

  .history-item {
      padding: 15px;
  }
}
</style>
